import { TriangleAlertIcon } from 'lucide-react';

import { getOutdatedBrowser, outdatedBrowserMessage } from '@/lib/browser-support';

interface OutdatedBrowserNoticeProps {
  userAgent?: string;
  'data-testid'?: string;
}

export function OutdatedBrowserNotice({
  userAgent = navigator.userAgent,
  'data-testid': dataTestId,
}: OutdatedBrowserNoticeProps) {
  const browser = getOutdatedBrowser(userAgent);
  if (!browser) return null;

  return (
    <div
      className="flex items-start gap-3 rounded-lg border border-[#E6C56A] bg-[#FFF6D8] px-4 py-3 text-left"
      data-testid={dataTestId}
    >
      <TriangleAlertIcon className="mt-0.5 h-5 w-5 shrink-0 text-[#C89212]" aria-hidden="true" />
      <p className="text-sm leading-5 text-[#6B5424]">{outdatedBrowserMessage(browser)}</p>
    </div>
  );
}
